import lodash from 'lodash';
import { makeAutoObservable, runInAction } from "mobx";

import { NotificationCreatedBroadcast, NotificationUnreadCountBroadcast } from 'shared/broadcasts';
import { notificationsQuery, notificationsUnreadCountQuery } from "shared/queries";

import { BroadcastModule } from "./BroadcastModule";

class NotificationsModuleClass {
    page = 1;
    filter = 'all';
    unreadCount = 0;
    items: any[] = [];
    isSubscribed = false;

    notificationCreatedBroadcast = new NotificationCreatedBroadcast(() => {
        this.fetchUnreadCount();
    });

    notificationUnreadCountBroadcast = new NotificationUnreadCountBroadcast(() => {
        this.fetchUnreadCount();
    });

    debouncedFetchUnreadCount = lodash.debounce(async () => {
        const response = await notificationsUnreadCountQuery();
        runInAction(() => {
            if (response.isSuccess && response.data) {
                this.unreadCount = response.data.count;
            }
        });
    }, 400);

    constructor() {
        makeAutoObservable(this, {
            isSubscribed: false,
            notificationCreatedBroadcast: false,
            notificationUnreadCountBroadcast: false,
            debouncedFetchUnreadCount: false,
            subscribe: false,
            unsubscribe: false,
        });
    }

    fetchUnreadCount = () => {
        this.debouncedFetchUnreadCount();
    }

    connect = () => {
        this.subscribe();
        this.fetchUnreadCount();
    }

    reset = () => {
        this.unsubscribe();
        this.debouncedFetchUnreadCount.cancel();
        this.unreadCount = 0;
    }

    fetch = async (page = 1, filter = 'all') => {
        runInAction(() => {
            this.page = page;
            this.filter = filter;
        })
        await notificationsQuery({ page, filter });
    }

    subscribe = () => {
        if (this.isSubscribed) {
            this.unsubscribe();
        }
        BroadcastModule.subscribe(this.notificationCreatedBroadcast);
        BroadcastModule.subscribe(this.notificationUnreadCountBroadcast);
        this.isSubscribed = true;
    }

    unsubscribe = () => {
        if (!this.isSubscribed) {
            return;
        }
        BroadcastModule.unsubscribe(this.notificationCreatedBroadcast);
        BroadcastModule.unsubscribe(this.notificationUnreadCountBroadcast);
        this.isSubscribed = false;
    }
}

export const NotificationsModule = new NotificationsModuleClass();
